/* Maison theme — core JS */
document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('[data-aos]');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Announcement bar rotation ---------- */
  var track = document.querySelector('.announcement-bar__track');
  if (track) {
    var items = track.children.length;
    var i = 0;
    if (items > 1) {
      setInterval(function () {
        i = (i + 1) % items;
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
      }, 4200);
    }
  }

  /* ---------- Mobile nav ---------- */
  var mobileToggle = document.querySelector('[data-mobile-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      document.body.classList.toggle('nav-open');
    });
  }

  /* ---------- Cart drawer ---------- */
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var openTriggers = document.querySelectorAll('[data-cart-open]');
  var closeTriggers = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  openTriggers.forEach(function (btn) { btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  closeTriggers.forEach(function (btn) { btn.addEventListener('click', openCart && closeCart); });
  if (overlay) overlay.addEventListener('click', closeCart);

  function refreshCartDrawer() {
    fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (!html) return;
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (newDrawer && drawer) drawer.innerHTML = newDrawer.innerHTML;
      })
      .catch(function () {});
  }

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.label = submitBtn.textContent; submitBtn.textContent = 'Ajout...'; }

    fetch('/cart/add.js', { method: 'POST', body: formData })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCartDrawer();
        openCart();
      })
      .catch(function (err) { console.error(err); })
      .finally(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.label; }
      });
  });

  /* ---------- Cart quantity update (drawer + cart page) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    var wrapper = btn.closest('[data-qty-wrapper]');
    var input = wrapper.querySelector('input[name="quantity"]');
    var step = parseInt(btn.dataset.qtyChange, 10);
    var newVal = Math.max(0, parseInt(input.value, 10) + step);
    input.value = newVal;
    updateCartLine(wrapper.dataset.line, newVal);
  });

  function updateCartLine(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCartDrawer();
        if (document.querySelector('[data-cart-page]')) window.location.reload();
      });
  }

  /* ---------- Quick add / variant selects on product cards & PDP ---------- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-variant-select]');
    if (!select) return;
    var form = select.closest('form');
    var variantId = select.value;
    var hiddenInput = form.querySelector('input[name="id"]');
    if (hiddenInput) hiddenInput.value = variantId;
  });

  /* ---------- Predictive search toggle ---------- */
  var searchToggle = document.querySelector('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  if (searchToggle && searchPanel) {
    searchToggle.addEventListener('click', function () {
      searchPanel.classList.toggle('is-open');
      var input = searchPanel.querySelector('input[type="search"]');
      if (input && searchPanel.classList.contains('is-open')) input.focus();
    });
  }
});
